import { render } from "./close.vue?vue&type=template&id=44603c73"
import script from "./close.vue?vue&type=script&lang=js"
export * from "./close.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__